import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
declare var google: any;

@Component({
  selector: 'app-map-modal',
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss']
})
export class MapModalComponent implements OnInit {
  map;
  mapMarkers = [];
  polyline;
  initialLocation: any;
  simMode = false;
  appMode = false;
  gpsMode = false;
  coordinates = [];
  flightPath: any;
  geofencePolyline: any;
  simLength = 0;
  appLength = 0;
  gpsLength = 0;
  truck = {url: 'assets/truck-icon.svg', scaledSize: new google.maps.Size(40, 40)};
  estimatedValues = {
    estDistanceKms: '',
    estDistanceMts: 0,
    estTime: ''
  };
  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public parentData: any,
              private dialogModal: MatDialogRef<MapModalComponent>) { }

  ngOnInit() {
    this.mapMarkers = [];
    this.initMap();
    this.simLength = (this.parentData.sim) ? this.parentData.sim.length : 0;
    this.appLength = (this.parentData.app) ? this.parentData.app.length : 0;
    this.gpsLength = (this.parentData.gps) ? this.parentData.gps.length : 0;
    if (this.appLength) {
      this.appMode = true;
    } else if (this.simLength) {
      this.simMode = true;
    } else if (this.gpsLength) {
      this.gpsMode = true;
    }
  }
  closeModal() {
    this.dialogModal.close();
  }
  initMap() {
    this.map = new google.maps.Map(document.getElementById('pathMaps'), {
      center: {lat: 12.960691, lng: 77.580116},
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    });
    google.maps.event.trigger(this.map, 'resize'); // Map fix
    if (this.parentData.onlyMarkers) {
      this.placeDriverMarkers();
    } else if (this.parentData.justMarker) {
      this.placeJustMarker(this.parentData.driverLoc);
    } else {
      this.placeAllFavMarkers();
    }
  }
  placeJustMarker(markers) {
    const markerOpt: any = {
      position: { lat: markers[1], lng: markers[0] },
      map: this.map,
      icon: this.truck
    };
    const bounds = new google.maps.LatLngBounds();
    const marker = new google.maps.Marker(markerOpt);
    const latLng = {
      lat: 0.0,
      lng: 0.0
    };
    latLng.lat = markers[1];
    latLng.lng =  markers[0];
    bounds.extend(latLng);
    this.mapMarkers.push(marker);
    marker.setMap(this.map);
    this.map.fitBounds(bounds);
  }
  placeDriverMarkers() {
    const bounds = new google.maps.LatLngBounds();

    this.parentData.pickups.forEach((pick, ind) => {
      this.placeMarker(pick.location.geo_point.coordinates, 'P' + (ind + 1));

      const latLng = {
        lat: 0.0,
        lng: 0.0
      };
      latLng.lat = pick.location.geo_point.coordinates[1];
      latLng.lng =  pick.location.geo_point.coordinates[0];
      bounds.extend(latLng);

    });

    this.parentData.deliveries.forEach((drop, ind) => {
      this.placeMarker(drop.location.geo_point.coordinates, 'D' + (ind + 1));

      const latLng = {
        lat: 0.0,
        lng: 0.0
      };
      latLng.lat = drop.location.geo_point.coordinates[1];
      latLng.lng =  drop.location.geo_point.coordinates[0];
      bounds.extend(latLng);
    });

    if (this.parentData.driverLoc.length) {
      this.placeMarker(this.parentData.driverLoc, '', {url: 'assets/truck-icon.svg', scaledSize: new google.maps.Size(40, 40)});
      const latLng = {
        lat: 0.0,
        lng: 0.0
      };
      latLng.lat = this.parentData.driverLoc[1];
      latLng.lng =  this.parentData.driverLoc[0];
      bounds.extend(latLng);
    }
    this.map.fitBounds(bounds);

  }

  removeMarkers(markers) {
    markers.forEach(element => {
      element.setMap(null);
    });
  }

  plotGeofence(geofence) {
    const path = new google.maps.geometry.encoding.decodePath(geofence);
    this.geofencePolyline = new google.maps.Polyline({
      path,
      geodesic: true,
      strokeColor: '#0080ff',
      strokeOpacity: 1.0,
      strokeWeight: 1
    });

    this.geofencePolyline.setMap(this.map);
  }
  drawPath() {
    if (this.flightPath) {
      this.flightPath.setMap(null); // Clear polyline
      this.coordinates = [];
    }
    const bounds = new google.maps.LatLngBounds();
    if (this.appMode) {
      this.parentData.app.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    } else if (this.simMode) {
      this.parentData.sim.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    } else if (this.gpsMode) {
      this.parentData.gps.forEach(element => {
        const latLng = {
          lat: 12.91739,
          lng: 77.8988169444444
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    }
    this.flightPath = new google.maps.Polyline({
      path: this.coordinates,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });

    this.flightPath.setMap(this.map);
    this.map.fitBounds(bounds);
    const src = this.coordinates[this.coordinates.length - 1];
    const destination = this.parentData.deliveries[this.parentData.deliveries.length - 1];
    if (src && destination) {
      this.getDistance(src, destination);
    }
}

getDistance(p, d) {
  const contxt = this;
  const service = new google.maps.DistanceMatrixService();
  service.getDistanceMatrix(
    {
      origins: [new google.maps.LatLng(p.lat, p.lng)],
      destinations: [new google.maps.LatLng(d[1], d[0])],
      travelMode: 'DRIVING',
      avoidHighways: false,
      avoidTolls: false,
    }, (distance, status) => {
      contxt.estimatedValues.estDistanceKms = distance.rows[0].elements[0].distance.text;
      contxt.estimatedValues.estDistanceMts = distance.rows[0].elements[0].distance.value;
      contxt.estimatedValues.estTime = distance.rows[0].elements[0].duration.text;
    }
  );
}
placeMarker(markers, label= '', icon: any = '') {
  const markerOpt: any = {
    position: { lat: markers[1], lng: markers[0] },
    map: this.map,
    label: label || ''
  };
  (icon) ? markerOpt.icon = icon : '';
  const marker = new google.maps.Marker(markerOpt);

  const infowindow = new google.maps.InfoWindow({
    content: this.parentData.synopsisText + '<br>' + this.parentData.date
  });
  if (label === '') {
    infowindow.open(this.map, marker);

    marker.addListener('click', function() {
      infowindow.open(this.map, marker);
    });
  }

  this.mapMarkers.push(marker);
  marker.setMap(this.map);

}

placeAllFavMarkers() {
  if (this.mapMarkers) {
    this.removeMarkers(this.mapMarkers);
  }
  this.drawPath();
  if(this.parentData.geofence){
    this.plotGeofence(this.parentData.geofence);
  }
  this.parentData.pickups.forEach((e, index) => {
    this.placeMarker(e, 'P' + (index + 1));
  });
  this.parentData.deliveries.forEach((e, index) => {
    this.placeMarker(e, 'D' + (index + 1));
  });
}
}
